import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCanViewSlug } from "../store/authSlice";

/**
 * Protects content by permission slug (must have can_view).
 * Use for route-level access so direct URL access is also restricted.
 * Example: <Route path="/admin/roles" element={<PermissionGuard slug="roles"><RolesAdminList /></PermissionGuard>} />
 */
export default function PermissionGuard({ children, slug }) {
  const canView = useSelector((state) => selectCanViewSlug(state, slug));
  const location = useLocation();

  if (!slug) return children;
  if (canView) return children;

  return <Navigate to="/" state={{ from: location }} replace />;
}
